import { render } from "./Sidebar.component.vue?vue&type=template&id=ddb04432&scoped=true&ts=true"
import script from "./Sidebar.component.vue?vue&type=script&lang=ts"
export * from "./Sidebar.component.vue?vue&type=script&lang=ts"

import "./Sidebar.component.vue?vue&type=style&index=0&id=ddb04432&scoped=true&lang=scss"

import exportComponent from "/builds/anisen/datamanagerweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddb04432"]])

export default __exports__